module.exports = __webpack_public_path__ + "static/img/mould1.28ea373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould1.png
// module id = Yt4i
// module chunks = 3